import React from 'react';
import { Checkbox, Button, ButtonProps, ButtonType } from '@riotgames/accounts-react-components';
import Recaptcha from 'react-recaptcha';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';
import withConsents from './withConsents';
import ConsentTypo from '../../comps/ConsentTypo';

const ForwardConsents = React.forwardRef(function Consents(
  { moveNext, isAvailable, recaptchaKey, onConsented, onCaptchaVerify, onCaptchaExpired, onCaptchaLoad },
  ref
) {
  return (
    <GridPanel
      title={'이용약관에 동의해 주세요.'}
      subTitle={''}
      button={<Button buttonType={ButtonType.submit} disabled={!isAvailable} onClick={moveNext} />}
    >
      <Grid direction={GridDirection.vertical} justify={GridJustify.spaceBetween} fill={true}>
        <Grid direction={GridDirection.vertical}>
          <ul className="consent-list" ref={ref}>
            <li>
              <Checkbox
                onCheckedChange={() => onConsented('privacy')}
                labelComponent={
                  <ConsentTypo strongText={'개인정보 수집 및 이용'} text={'에 동의 (필수)'} consentName={'privacy'} />
                }
              />
            </li>
            <li>
              <Checkbox
                onCheckedChange={() => onConsented('external')}
                labelComponent={
                  <ConsentTypo strongText={'개인정보 국외 이전'} text={'에 동의 (필수)'} consentName={'external'} />
                }
              />
            </li>
          </ul>
        </Grid>
        <Grid direction={GridDirection.vertical} className="grid-recaptcha">
          <Recaptcha
            sitekey={recaptchaKey}
            render="explicit"
            hl={'ko'}
            verifyCallback={onCaptchaVerify}
            expiredCallback={onCaptchaExpired}
            onloadCallback={onCaptchaLoad}
          />
        </Grid>
      </Grid>
    </GridPanel>
  );
});
ForwardConsents.displayName = 'ForwardConsents(Consents)';

export default withConsents(ForwardConsents);
